import { EmailRestrictionConfirmationModal } from "./Modal";
import { EmailRestrictionConfirmationModalProps, RestrictedEmailConfirmationResponse } from "./types";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";

export { type RestrictedEmailConfirmationResponse };

export function openEmailRestrictedFileConfirmation(form: MailMessage) : Promise<RestrictedEmailConfirmationResponse> {
    return createConfirmation<EmailRestrictionConfirmationModalProps, RestrictedEmailConfirmationResponse>(confirmable(EmailRestrictionConfirmationModal))({
        dialogId: 'confirm_restricted_file_email_modal',
        defaultValues: form
    });
}